// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const getInitialValues = unitType => ({
  advancedSearch: ['show'], // this is used to handle the open/close state of the form
  antennaField: 'antennaCode', // controls display of antenna input type. (antennaCode | antennaCompanyId)
  antennaCode: '',
  antennaCompanyId: [],
  antennaSpecId: null,
  asr: '',
  bandId: [],
  billcode: '',
  contactId: [],
  frequency: '',
  jobCode: '', // use LIKE because of trailing whitespces
  latitude: '',
  licenseBasisId: [],
  longitude: '',
  pathName: '', // use LIKE because of trailing whitespces
  pagination: null,
  polarizationId: '',
  protectFlag: '',
  radioField: 'radioCode', // controls display of radio input type. (radioCode | radioCompanyId)
  radioCode: '',
  radioFavoriteId: null,
  radioId: null,
  radioCompanyId: [],
  radius: '',
  radiusUnit: unitType,
  rcnNumber: '',
  'site1-callSign': '',
  'site1-siteName': '',
  'site2-callSign': '',
  'site2-siteName': '',
  segmentStatusId: [],
  stateId: [],
  ulsFileNumber: '',
})

export default getInitialValues
